<template>
  <a-layout-content :class="isSPCL ? '' : 'p-all'">
    <a-spin :spinning="loading.page" tip="Data sedang diproses ...  ">
      <a-row :gutter="{xs:0, lg:8}">
        <a-col :xs="24" :lg="8">
          <a-card>
            <span class="m-text-title" slot="title">Filter</span>
            <div class="d-flex flex-column">
              <a-input-search v-model="search" @change="searching" placeholder="Pencarian ... " />
              <div v-if="!isSPCL">
                <h4 class="m-top">Search Base On</h4>
                <a-radio-group
                  buttonStyle="solid"
                  v-model="category"
                  @change="searching"
                >
                  <a-radio-button value="tlc_pembuat">TLC Pembuat</a-radio-button>
                  <a-radio-button value="tlc_pelaksana">TLC Pelaksana</a-radio-button>
                </a-radio-group>
              </div>
              <a-collapse activeKey="1" class="m-top">
                <a-collapse-panel key="1">
                  <span slot="header">Cari Lebih Lengkap</span>
                  <div class="m-form-item-wrapper">
                    <label for="tanggalTransaksi">Tanggal Transaksi</label>
                    <a-date-picker
                      v-model="transactionDt"
                      @change="searching"
                      :format="getDefaultDateFormat"
                      allowClear
                    />
                  </div>
                  <!-- <div class="m-form-item-wrapper">
                    <label for="tanggalTransaksi">Status</label>
                    <a-select
                      placeholder="Ex: Approved ... "
                      v-model="status"
                      @change="searching"
                      class="w-full"
                      initialValue="delivered"
                      allowClear
                    >
                      <a-select-option value="delivered">Delivered</a-select-option>
                      <a-select-option value="approved">Approved</a-select-option>
                      <a-select-option value="on process">On Process</a-select-option>
                      <a-select-option value="revised">Revised</a-select-option>
                      <a-select-option value="rejected">Rejected</a-select-option>
                    </a-select>
                  </div> -->
                </a-collapse-panel>
              </a-collapse>
            </div>
          </a-card>
        </a-col>
        <a-col :xs="24" :lg="16">
          <H-Datalist
            title="Surat Perintah Lembur"
            editLink="editSPL"
            :isSpecialMenu="isSPCL"
            :createLink="isSPCL ? '' : 'createSPL'"
            :manifestLink="manifestSpl"
            :dataList="basedData"
          >
            <div slot="title-extended" slot-scope="{item}">
              <Status :status="item.status" v-if=" item.status=='Cancelled' "/>
            </div>
            <!-- <div slot="action-button">

            </div>
              <a-button type="primary" @click="handleCreate()">
                <a-icon type="plus" />
                  Baru
              </a-button>
            </div>
            <template slot="change-button" slot-scope="{item}">
              <a-button type="danger" @click="handleCreate(item)">
                <a-icon type="edit" />&nbsp; Ubah Data
              </a-button>
            </template> -->
          </H-Datalist>
        </a-col>
      </a-row>
    </a-spin>
  </a-layout-content>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import DataList from "@/components/Datalist";
import moment from "moment";
import _ from "lodash";
import Status from "@/components/Status.vue";

export default {
  components: {
    "H-Datalist": DataList,
    Status,
  },
  name: "SPL_list",
  data() {
    return {
      spllist: [],
      basedList: [],
      workingDay: [1, 2, 3, 4, 5],
      visible: false,
      transactionDt: null,
      search: "",
      status: "",
      dates: [],
      disable: false,
      mode: "Create",
      datasource: {},
      selectAttribute: {
        dot: true
      },
      id_cuti: "",
      category: "tlc_pembuat",
      loading: {
        page: false,
        save: false
      }
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.fetchData().then(() => {
      if (!this.isSPCL) {
        this.spllist = _.filter(this.basedList, (obj) => obj.tlc_create && obj.tlc_create.toLowerCase() == this.getAuth.username.toLowerCase())
        if (this.spllist.length > 0) {
          this.category = "tlc_pembuat"
        } else {
          this.category = "tlc_pelaksana"
          this.searching()
        }
      } else {
        this.category = null
      }
    });
  },
  watch: {
    dates() {
      if (this.mode === "Create") {
        if (this.dates.length > this.getCuti.sisa_cuti) {
          this.$notification.warning({
            message: "Error",
            description:
              "Permintaan Cuti Melebihi Batas Cuti Tahunan!"
          });
          this.disable = true;
        } else {
          this.disable = false;
        }
      } else {
        this.disable = false;
      }
    },
    search() {
      // if (this.search) {
        this.searching();
      // }
    },
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getCuti",
      "getDefaultDateFormat",
      "getStandartFormatDate"
    ]),
    basedData() {
      let output = [];

      this.spllist.forEach(data => {
        output.push({
          title: data.spl_no,
          subdesc: [
            [{ label: "Tanggal Transaksi / Pembuat", value: moment(data.create_dt).format(this.getStandartFormatDate) + " / " + data.tlc_create }],
            [{ label: "Atas Perintah", value: data.commander }],
            [{ label: "Pelaksana", value: data.pelaksana.replaceAll(",",", ") }],
            [{ label: "Lokasi ", value: data.lokasi }],
            //[{ label: "description ", value: data.uraian + " jan mazeh zaenal is the best from the best employee ever" }],
            // "Uraian Tugas : "+data.uraian + " jan mazeh zaenal is the best from the best employee ever",
          ],
          description: "Uraian Tugas : " + data.uraian,
          status: data.status,
          id: data.spl_id,
          timeline: JSON.parse(data.status_app),
        });
      });

      return output;
    },
    initialData() {
      if (this.mode === "Create") {
        return {
          sisaCuti: this.getCuti.sisa_cuti,
          tanggal_cuti: moment(this.limaHari(moment(), 6)).format(
            this.getDefaultDateFormat
          ),
          keperluan: ""
        };
      } else {
        return {
          sisaCuti: this.getCuti.sisa_cuti,
          keperluan: this.datasource.data.keperluan,
          approval: this.datasource.data.approval
        };
      }
    },
    isSPCL() {
      return this.$route.meta.isSPCL ? true : false
    },
    kodeMenu() {
      return localStorage.getItem('mns_')
    },
    manifestSpl() {
      let result = "manifestSpl"
      if (this.kodeMenu == "9") {
        result = "manifestSplDir"
      } else if (this.kodeMenu == "4") {
        result = "manifestSplHrd"
      } else if (this.kodeMenu == "12") {
        result = "manifestSplAL"
      }
      return result
    }
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.handleOkProcess);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleOkProcess);
  },
  methods: {
    moment,
    ...mapActions({}),
    searching() {
      if (this.isSPCL) {
        this.spllist = this.basedList
      } else {
        if (this.category == "tlc_pelaksana") {
          this.spllist = _.filter(this.basedList, (obj) => obj.pelaksana && obj.pelaksana.includes(this.getAuth.username))
        } else {
          this.spllist = _.filter(this.basedList, (obj) => obj.tlc_create && obj.tlc_create.toLowerCase() == this.getAuth.username.toLowerCase())
        }
      }

      if (this.search) {
          this.spllist = this.spllist.filter(
            obj =>
              obj.spl_no.toLowerCase().indexOf(this.search.trim().toLowerCase()) >= 0 ||
              obj.pelaksana.toLowerCase().indexOf(this.search.trim().toLowerCase()) >= 0 ||
              obj.commander.toLowerCase().indexOf(this.search.trim().toLowerCase()) >= 0 ||
              obj.uraian.toLowerCase().indexOf(this.search.trim().toLowerCase()) >= 0 ||
              obj.create_dt.toLowerCase().indexOf(this.search.trim().toLowerCase()) >= 0 ||
              obj.c_proyek.toLowerCase().indexOf(this.search.trim().toLowerCase()) >= 0 ||
              obj.status.toLowerCase().indexOf(this.search.trim().toLowerCase()) >= 0 ||
              obj.lokasi.toLowerCase().indexOf(this.search.trim().toLowerCase()) >= 0
          );
      }

      // if (this.status) {
      //   this.spllist = this.spllist.filter(
      //     obj =>
      //       obj.status &&
      //       obj.status.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
      //   );
      // }

      if (this.transactionDt) {
        let searchDate = moment(this.transactionDt).format(
          this.getStandartFormatDate
        );
        this.spllist = this.spllist.filter(
          obj => moment(obj.create_dt).format(
            this.getStandartFormatDate
          ) === searchDate
        );
      }

      if (!this.search && !this.status && !this.transactionDt && !this.category) {
        this.spllist = this.basedList;
      }
    },
    async fetchData() {
      this.loading.page = true
      let params = this.isSPCL ?
        {
          tlc: this.getAuth.username,
          id: this.isSPCL ? this.kodeMenu : null
        } :
        {
          tlc: this.getAuth.username,
        }
      await axios({
        method: "get",
        url: this.$serviceUrl + (this.isSPCL ? "monitoring/spl" : "spl"),
        params: params,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.spllist = response.data.data;
          this.basedList = response.data.data;
          this.loading.page = false
        })
        .catch(() => {
          //console.log(err.response);
          this.loading.page = false
        });
    },
    handleCreate() {
      this.$router
        .push({ name: "createSPL", params: {} })
        .catch(console.log());
    },
    handleOk() {
      this.confirmMessage("confirm-save");
    },
    handleOkProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.loading.save = true;
        let post = new FormData();

        let formatDate = [];
        let formEdit = [];
        for (let i = 0; i < this.dates.length; i++) {
          formatDate.push(
            moment(this.dates[i]).format(this.getStandartFormatDate)
          );
        }

        post.append("tlc", this.getAuth.username);
        post.append("keperluan", values.keperluan);
        post.append("approval", values.approval);
        post.append("tgl_cuti[]", formatDate);

        if (this.mode === "Edit") {
          formEdit = {
            tlc: this.getAuth.username,
            keperluan: values.keperluan,
            approval: values.approval,
            tgl_cuti: formatDate,
            id_cuti: this.id_cuti
          };
        }

        axios({
          method: this.mode === "Create" ? "post" : "put",
          url: this.$serviceUrl + "cuti",
          processData: false,
          data: this.mode === "Create" ? post : formEdit,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "Content-Type":
              this.mode === "Create"
                ? "multipart/form-data"
                : "application/json",
            "X-API-KEY": this.getAuth.apikey
          }
        })
          .then(response => {
            if (this.mode === "Edit") {
              this.$notification.success({
                message: "Sukses",
                description: "Data telah berhasil diubah!"
              });
            } else {
              this.$notification.success({
                message: "Sukses",
                description: "Data telah berhasil diproses!"
              });
            }
            this.loading.save = false;
            this.$router.go({ name: "landingCuti" });
            this.visible = false;
          })
          .catch(err => {
            this.$notification.error({
              message: "Error",
              description: err.response.data.message
            });
            // if (err.response.data.message == "Jatah Cuti Anda Sudah Habis") {
            //   this.$notification.error({
            //     message: "Error",
            //     description:
            //       "Jatah Cuti Kamu Sudah Habis, Kamu Tidak Bisa Melakukan Permohonan Cuti ... "
            //   });
            // }

            this.loading.save = false;
          });
      });
    },
    handleCancel() {
      this.visible = false;
      this.dates = [];
      this.id_cuti = "";
    },
    limaHari(date, days) {
      date = moment(date);
      while (days > 0) {
        date = date.add(1, "days");
        if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
          days -= 1;
        }
      }
      return date._d;
    },
  }
};
</script>

<style>
</style>